import React from 'react'

function Inventory() {
  return (
    <h1>Inventory</h1>
  )
}

export default Inventory